<template src="./openApiTokenDetail.template.html"></template>
<script>
    export default {
        name: "openApiTokenDetail",
        props: [""],
        data() {
            return {
                displaySectionValue: "apiKey",
                ratePlanList: [],
                userList: [],
                apiUserDetail: {
                    AuthenticationKey: null
                },
                selectedUser: null,
                token: null,
                filterObj: {
                    SortBy: null,
                    SortOrder: null
                },
                IPAddressList: [
                    {
                        APIUserId: null, IPAddress: ""
                    }
                ]

            };
        },
        methods: {
            changeInDerivedRateplan() {
                let vm = this;
                if (vm.apiUserDetail.RateplanId == vm.apiUserDetail.derivedRateplanId) {
                    vm.apiUserDetail.derivedRateplanId = null
                }
                if (vm.apiUserDetail.derivedRateplanId == null || vm.apiUserDetail.derivedRateplanId == 'null') {
                    vm.apiUserDetail.Amount = 0
                }
            },
            GetRateplanList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_RatePlanList",
                    params: {
                        ModuleAction: "Get_RatePlanList",
                        StatusId: 1,
                        SearchText: null,
                        Tagtext: null
                    },
                    callback: function (err, response) {

                        if (err) {
                            return
                        }
                        if (response) {
                            console.log("GetRateplanList", response)
                            vm.ratePlanList = response[1]

                        }
                    }
                })
            },
            IpAddressData(addressList) {
                let vm = this;
                let list = vm.IPAddressList.map(x => x.IPAddress);
                return list.join()
            },
            displaySection(name) {
                let vm = this;
                vm.displaySectionValue = name;
            },
            Save_APIUser_Details() {
                let vm = this;
                let list = vm.IPAddressList.map(x => x.IPAddress);
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_APIUser_Details",
                    params: {
                        ModuleAction: "Save_APIUser_Details",
                        userId: vm.selectedUser.UserId,
                        ipAddress: list.join(),
                        apiUserDetail: vm.apiUserDetail,
                        APIUserId: vm.$route.params.apiId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Error in Save_APIUser_Details => ", err);
                            return;
                        }
                        if (response) {
                            console.log("response in Save_APIUser_Details", response);
                            // vm.token = response
                            if (response[0] && response[0].length > 0 && response[0][0].ErrorMessage) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error",
                                    message: response[0][0].ErrorMessage
                                });
                                return
                            }
                            if (response[1] && response[1].length > 0) {
                                if (vm.$route.params.apiId == -1) {
                                    vm.$router.push("/openApiTokenDetail/" + response[1][0].APIUserId);
                                }
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "success",
                                    message: "Api user saved successfully",

                                });

                            }
                            vm.Get_APIUser_Details();
                            if (vm.apiUserDetail.CalculateDerivedRates == 1) {
                                vm.CalculateDerivedRatesForWheelhouse()
                            }

                        }
                    }
                });
            },
            CalculateDerivedRatesForWheelhouse() {
                let vm = this
                var DerivedOffsetAmount = 0
                const sign = vm.apiUserDetail.isPositive ? "+" : "-";
                const amount = vm.apiUserDetail.Amount || 0;
                DerivedOffsetAmount = amount ? sign + amount : amount;

                vm.$store.dispatch("dataRequestHandler", {
                    key: "CalculateDerivedRates_Integration",
                    params: {
                        ModuleAction: "CalculateDerivedRates_Integration",
                        derivedRateplanId: vm.apiUserDetail.derivedRateplanId,
                        isPercentage: vm.apiUserDetail.isPercentage,
                        Amount: DerivedOffsetAmount,
                        RatePlanId: vm.apiUserDetail.RateplanId,
                        integrationId: 4
                    },
                    callback: function (err, response) {

                    }
                })
            },
            copyToken(token) {
                let vm = this;
                var Token = document.createElement("input");
                document.body.appendChild(Token);
                Token.value = token;
                Token.select();
                document.execCommand("copy", false);
                Token.remove();
            },
            generateApiKey() {
                let vm = this;
                let list = vm.IPAddressList.map(x => x.IPAddress);
                vm.$store.dispatch("dataRequestHandler", {
                    key: "generateApiKey",
                    params: {
                        ModuleAction: "generateApiKey",
                        user: vm.selectedUser,
                        ipAddress: list.join(),
                        apiUserDetail: vm.apiUserDetail
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Error in generateApiKey => ", err);
                            return;
                        }
                        if (response) {
                            console.log("response in generateApiKey", response);
                            vm.apiUserDetail.AuthenticationKey = response;
                        }
                    }
                });
            },
            getUserList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetUserList",
                    params: {
                        ModuleAction: "GetUserList",
                        filterObj: vm.filterObj
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        } else {
                            console.log("response in GetUserList", response);
                            if (response.recordsets[0] && response.recordsets[0].length > 0) {
                                vm.userList = response.recordsets[0];
                            }
                        }
                    }
                });
            },
            Get_APIUser_Details() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_APIUser_Details",
                    params: {
                        ModuleAction: "Get_APIUser_Details",
                        userId: vm.$route.params.apiId
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        } else {
                            console.log("response in Get_APIUser_Details", response);

                            vm.apiUserDetail = response[0] && response[0][0] ? response[0][0] : { AuthenticationKey: null };
                            vm.selectedUser = response[2] && response[2][0] ? response[2][0] : null
                            if (response[1] && response[1].length > 0) {
                                vm.IPAddressList.splice(0, vm.IPAddressList.length, ...response[1]);
                            }
                        }
                    }
                });
            },
            addIpAddress() {
                let vm = this;
                vm.IPAddressList.push({ APIUserId: null, IPAddress: "" });
            }
        },
        computed: {
            fncAPIKey() {
                let vm = this;

                return vm.$store.state.userEntitlementList.hasOwnProperty("fncAPIKey") ?
                    vm.$store.state.userEntitlementList.fncAPIKey : null;

            }
        },
        mounted() {
            let vm = this;
            vm.getUserList();
            vm.Get_APIUser_Details();
            vm.GetRateplanList();
        },
        watch: {}
    };
</script>